import {AccordionFeedbackMediaProps, FeedbackMediaProps} from "../types/feedback-media-modal.types";

export const feedbackMediaModalName = 'feedback-media';

export const accordionFeedbackMedia: Array<AccordionFeedbackMediaProps> = [
  {
    label: 'Фото',
    type: 'image'
  },
  {
    label: 'Видео',
    type: 'video'
  }
]

export const defaultFeedbackMediaProps: FeedbackMediaProps = {
  url: '',
  index: 0
}
